package com.example.mystybag.core.defines

object UtilsTransfersDefines {
    // Bank Transfer Patterns
    const val IBAN_PATTERN                                  = "[^a-zA-Z0123456789]+"
    const val BENEFICIARY_LATIN_PATTERN                     = "[^a-zA-Z-0123456789 ]+$"
    const val NAME_LATIN_PATTERN                            = "[^a-zA-Z\\- ]+$"
    const val ACCOUNT_NAME_LATIN_CYRILLIC_PATTERN           = "[^a-zA-Zа-яА-Я-0123456789 ]+"
    const val PAYMENT_REASON_LATIN_CYRILLIC_PATTERN         = "[^а-яА-Яa-zA-Z'()+,./:?0123456789\\n\\r -]+"
    const val GIFT_CARD_PLASTIC_PATTERN                     = "[^а-яА-Яa-zA-ZЁёЫыЭэÏïЄє0123456789!/.'& -]+"
    const val ONLY_NUMBERS_PATTERN                          = "[^0-9]+"
    const val NAME_LATIN_CYRILLIC_PATTERN                   = "[^а-яА-Яa-zA-Z\\- ]+$"
    const val CYILLIC_LATIN_EGIFT_CARD_WISH                = "[^a-zA-Zа-яА-ЯЁёЫыЭэÏïЄє!?()/.,+':&0123456789 -]+"
    const val EMAIL_PATTERN                                 = "[a-zA-Z0-9+._%\\-+]{1,256}@[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}(\\.[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25})+"
    const val EMAIL_SYMBOLS_PATTERN                         = "[^a-zA-Z0-9+._%\\-+@]+"
    const val CYRILLIC_PATTERN                              = "[а-яА-Я]"
    const val CYRILLIC_PART_IN_PATTERN                      = "а-яА-Я"
    const val PHONE_PATTERN                                 = "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*\$"
    const val PHONE_INPUT                                   = "[^0-9]"

    const val LATIN_CYRILLIC_NUMBERS                        = "[^äöüßñáéíóúÄÖÜẞÑÁÉÍÓÚа-яА-Яa-zA-Z'()+,./:?0123456789 -]+"
    const val PHONE_MAX_LENGTH                              = 20
    const val POSTAL_CODE_MAX_LENGTH                        = 10
    const val CITY_MAX_LENGTH                               = 51
    const val ADDRESS_MAX_LENGTH                            = 50
    const val NAME_MAX_LENGTH                               = 35
    const val EMAIL_LENGTH                                 = 100
}

enum class TextFieldType {
    ANY,
    POSTAL_CODE,
    ADDRESS,
    NAME,
    PHONE,
    CITY,
    CITY_BG,
    POSTAL_CODE_BG,
    ADDRESS_BG,
    EMAIL
}